import React, { Fragment } from 'react';
import _ from 'lodash';

import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from 'reactstrap';

import qs from 'qs';
import { withRouter } from 'react-router-dom';

import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';


class CommercialFilter extends baseFilter {

    constructor(props) {
        super(props);

        this.renderCommercialCheckboxes =
            this.renderCommercialCheckboxes.bind(this);

        this.toggleCheckbox =
            this.toggleCheckbox.bind(this);

        this.updateAPIURL =
            this.updateAPIURL.bind(this);

        this.processResponse =
            this.processResponse.bind(this);

        this.toggleCollapse =
            this.toggleCollapse.bind(this);


        this.state = {
            filters: {
                Yes: {
                    active: false,
                    count: 0
                }
            },

            isOpen: false,

            fields: [
                "Yes"
            ],

            activeCount: 0
        };


        this.aggregates = {
            'commercial_available': 'count'
        };
    }


    static getDerivedStateFromProps(newprops, oldstate) {

        const querystring = qs.parse(
            newprops.location.search,
            {
                ignoreQueryPrefix: true
            }
        );

        const activeFilters =
            CommercialFilter.getActiveFiltersFromQS(
                querystring,
                'commercial'
            );


        return {
            filters: {
                Yes: {
                    ...oldstate.filters.Yes,
                    active:
                        activeFilters.indexOf('Yes') >= 0
                }
            },

            activeCount:
                activeFilters.length
        };
    }


    static getActiveFiltersFromQS(
        qs_obj,
        field,
        defaultValue = [],
        sep = "_"
    ) {

        return (
            field in qs_obj
                ? _.split(
                    _.get(qs_obj, field),
                    sep
                )
                : defaultValue
        );
    }


    updateAPIURL(api_qs, newlistprops) {

        const new_qs = qs.parse(
            newlistprops.location.search,
            {
                ignoreQueryPrefix: true
            }
        );


        const activeCommercialFilters =
            CommercialFilter.getActiveFiltersFromQS(
                new_qs,
                'commercial'
            );


        /*
         * Only apply the filter when "Yes" is selected.
         */
        if (
            activeCommercialFilters.length > 0 &&
            activeCommercialFilters.indexOf('Yes') >= 0
        ) {

            const filter_qs = {
                name: "commercial_available",
                op: "eq",
                val: true
            };


            api_qs.filter = [
                ...(api_qs.filter || []),
                filter_qs
            ];
        }


        return _.merge(
            api_qs,
            {
                agg: this.aggregates
            }
        );
    }


    processResponse(response) {

        const resp_agg =
            this.get_agg_values(response);


        const agg_field =
            _.keys(this.aggregates)[0];


        if (!resp_agg) {
            return;
        }


        /*
         * Get the count aggregation using the same
         * structure as the other filters.
         */
        const counts = _.get(
            resp_agg,
            [
                agg_field,
                this.aggregates[agg_field]
            ],
            {}
        );


        console.log(
            'Commercial aggregate:',
            resp_agg
        );

        console.log(
            'Commercial counts:',
            counts
        );


        /*
         * Try all the response formats that your API
         * may return.
         */
        let yesCount = 0;


        /*
         * Format:
         *
         * {
         *   true: 123
         * }
         */
        if (
            typeof counts === 'object' &&
            counts !== null
        ) {

            if (
                counts.true !== undefined
            ) {
                yesCount =
                    Number(counts.true) || 0;
            }


            /*
             * Format:
             *
             * {
             *   True: 123
             * }
             */
            else if (
                counts.True !== undefined
            ) {
                yesCount =
                    Number(counts.True) || 0;
            }


            /*
             * Format:
             *
             * {
             *   "true": {
             *      count: 123
             *   }
             * }
             */
            else if (
                counts.true &&
                typeof counts.true === 'object'
            ) {

                yesCount =
                    Number(
                        counts.true.count
                    ) || 0;
            }


            /*
             * Format:
             *
             * {
             *   "True": {
             *      count: 123
             *   }
             * }
             */
            else if (
                counts.True &&
                typeof counts.True === 'object'
            ) {

                yesCount =
                    Number(
                        counts.True.count
                    ) || 0;
            }
        }


        /*
         * Some versions of the API return the aggregate
         * directly under meta.agg rather than through
         * get_agg_values().
         */
        if (yesCount === 0) {

            const directTrue =
                _.get(
                    response,
                    'meta.agg.commercial_available.true'
                );


            const directTrueCount =
                _.get(
                    response,
                    'meta.agg.commercial_available.count.True'
                );


            if (
                directTrue !== undefined
            ) {

                yesCount =
                    Number(directTrue) || 0;

            } else if (
                directTrueCount !== undefined
            ) {

                yesCount =
                    Number(directTrueCount) || 0;
            }
        }


        this.setState({
            filters: {
                Yes: {
                    ...this.state.filters.Yes,
                    count: yesCount
                }
            }
        });
    }


    toggleCollapse() {

        this.setState({
            isOpen: !this.state.isOpen
        });
    }


    toggleCheckbox(event) {

        const commercial =
            event.target.name;


        const current_qs = qs.parse(
            window.location.search,
            {
                ignoreQueryPrefix: true
            }
        );


        let commercialFilter =
            ('commercial' in current_qs)
                ? _.split(
                    current_qs.commercial,
                    '_'
                )
                : [];


        if (event.target.checked) {

            if (
                commercialFilter.indexOf(
                    commercial
                ) === -1
            ) {

                commercialFilter.push(
                    commercial
                );
            }

        } else {

            commercialFilter =
                commercialFilter.filter(
                    item =>
                        item !== commercial
                );
        }


        current_qs.commercial =
            commercialFilter.length > 0
                ? _.join(
                    commercialFilter.sort(),
                    '_'
                )
                : undefined;


        /*
         * Reset pagination when a filter changes.
         */
        current_qs.page = undefined;


        this.props.history.push(
            window.location.pathname +
            qs.stringify(
                current_qs,
                {
                    addQueryPrefix: true
                }
            )
        );
    }


    renderCommercialCheckboxes() {

        return (
            <Fragment>

                {_.map(
                    _.toPairs(this.state.filters),
                    ([commercial, details]) => {

                        return (
                            <FormGroup
                                check
                                key={commercial}
                            >

                                <Input
                                    type="checkbox"
                                    name={commercial}
                                    onChange={
                                        this.toggleCheckbox
                                    }
                                    checked={
                                        !!details.active
                                    }
                                />

                                {' '}

                                <Label
                                    className="ml-4 mt-1"
                                    check
                                >

                                    {commercial}

                                    <span className="secondary">
                                        {' '}
                                        (
                                        {Number(details.count) || 0}
                                        )
                                    </span>

                                </Label>

                            </FormGroup>
                        );
                    }
                )}

            </Fragment>
        );
    }


    componentDidMount() {

        this.props.registerResponse(
            this.processResponse
        );

        this.props.registerRequest(
            this.updateAPIURL
        );
    }


    componentWillUnmount() {

        this.props.unregisterResponse(
            this.processResponse
        );

        this.props.unregisterRequest(
            this.updateAPIURL
        );
    }


    render() {

        return (
            <Card className="genetic-filters mb-2 z0 hover">

                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >

                    <div className="d-inline w-50">
                        Commercially Available
                    </div>


                    <div className="d-inline-block">

                        {this.state.activeCount > 0 && (
                            <strong>
                                {this.state.activeCount + ' active'}
                            </strong>
                        )}

                    </div>


                    <CollapseButton
                        isOpen={this.state.isOpen}
                        onClick={this.toggleCollapse}
                    />

                </CardHeader>


                <Collapse
                    isOpen={this.state.isOpen}
                >

                    <CardBody>

                        {this.renderCommercialCheckboxes()}

                    </CardBody>

                </Collapse>

            </Card>
        );
    }
}


export default withRouter(CommercialFilter);